import type { EnglishDictionary } from './en'

export const es = {
  nav: {
    primary: 'Principal',
    inbox: 'Bandeja',
    knowledge: 'Conocimiento',
    projects: 'Proyectos',
    users: 'Usuarios',
    config: 'Config',
    aiUsage: 'Uso de IA',
    health: 'Salud',
    submit: 'Enviar',
    myTickets: 'Mis tickets',
    profile: 'Perfil',
    switchTenant: 'Cambiar organizacion',
    signOut: 'Cerrar sesion',
    role: {
      admin: 'Admin',
      expert: 'Experto',
    },
    widgets: {
      ticketsThisMonth: 'Tickets este mes',
      lastMonth: '{count} el mes pasado',
      weekStreak: 'Racha semanal',
      resolved: 'Resueltos',
      kbArticles: 'Articulos KB',
      responsesHelped: 'Respuestas ayudadas',
      responsesHelpedTitle: 'Tus entradas de KB se usaron en borradores para {count} tickets que recibieron respuesta',
    },
  },
  roles: {
    line_manager: 'Gerente de linea',
    expert: 'Experto',
    admin: 'Admin',
    system: 'Sistema',
  },
  priority: {
    critical: 'Critica',
    high: 'Alta',
    medium: 'Media',
    low: 'Baja',
  },
  ticket: {
    status: {
      DRAFT: 'Borrador',
      SUBMITTED: 'Enviado - analizando...',
      NEEDS_INFO: 'Se necesita mas informacion',
      TRIAGED: 'Clasificado - esperando experto',
      AWAITING_EXPERT: 'Listo para revision',
      EXPERT_REVIEWING: 'En revision experta',
      RESPONSE_DRAFTING: 'Preparando respuesta...',
      RESPONSE_READY: 'Respuesta lista',
      RESPONDED: 'El experto respondio',
      AWAITING_REPLY: 'Esperando tu respuesta',
      CLOSED: 'Cerrado',
      ARCHIVED: 'Archivado',
    },
  },
  settings: {
    profileTitle: 'Perfil',
    personalInfo: 'Informacion personal',
    firstName: 'Nombre',
    lastName: 'Apellido',
    timeZone: 'Zona horaria',
    language: {
      label: 'Idioma preferido',
    },
    saved: 'Configuracion actualizada correctamente.',
    save: 'Guardar configuracion',
    saving: 'Guardando...',
    error: 'No se pudo guardar. Intentalo de nuevo.',
    activity: 'Actividad',
    streak: 'Racha de {count} semanas',
    actions: '{count} acciones',
    stats: 'Estadisticas',
    ticketsThisMonth: 'Tickets este mes',
    currentStreak: 'Racha actual',
    totalResolved: 'Total resueltos',
    activeKbArticles: 'Articulos KB activos',
    totalResponsesHelped: 'Total de respuestas ayudadas por tu KB',
    calendar: {
      ticketsSubmitted: 'tickets enviados',
      expertActions: 'acciones expertas',
      mon: 'Lun',
      wed: 'Mie',
      fri: 'Vie',
    },
  },
  loginConfirm: {
    heading: 'Iniciar sesion en',
    body: 'Haz clic en el boton de abajo para completar el inicio de sesion de {email}.',
    cta: 'Completar inicio de sesion',
    back: '← Usar un correo diferente',
  },
  onboarding: {
    title: 'Una cosa mas',
    body: 'Dinos tu nombre para que expertos y gerentes de linea puedan reconocerte.',
    continue: 'Continuar',
    saving: 'Guardando...',
    error: 'Algo salio mal. Intentalo de nuevo.',
  },
  submit: {
    title: 'Enviar un problema',
    intro: 'Completa todos los campos. Un experto respondera lo antes posible.',
    project: 'Proyecto',
    projectHelp: 'Si tu proyecto no aparece, contacta a un experto o admin para agregar el proyecto que necesitas.',
    noProjects: 'No hay proyectos activos disponibles',
    selectProject: 'Selecciona proyecto...',
    projectRequired: 'Selecciona un proyecto.',
    department: 'Departamento',
    selectDepartment: 'Selecciona departamento...',
    departmentRequired: 'Selecciona un departamento.',
    dateOfOccurrence: 'Fecha de ocurrencia',
    dateFuture: 'La fecha de ocurrencia no puede estar en el futuro. Elige hoy o una fecha anterior.',
    dateRequired: 'La fecha de ocurrencia es obligatoria.',
    issueCategory: 'Categoria del problema',
    selectCategory: 'Selecciona categoria...',
    categoryRequired: 'Selecciona una categoria.',
    affectedSystem: 'Sistema / proceso afectado',
    selectSystem: 'Selecciona sistema...',
    systemRequired: 'Selecciona un sistema afectado.',
    priority: 'Prioridad',
    selectPriority: 'Selecciona prioridad...',
    priorityRequired: 'Selecciona una prioridad.',
    actionRequested: 'Accion solicitada',
    selectAction: 'Selecciona accion...',
    actionRequired: 'Selecciona una accion.',
    description: 'Descripcion del problema',
    descriptionPlaceholder: 'Describe el problema con el mayor detalle posible...',
    descriptionRequired: 'La descripcion es obligatoria.',
    successCriteria: 'Como se ve el exito?',
    successCriteriaPlaceholder: 'Describe el resultado que resolveria este problema...',
    successCriteriaRequired: 'Describe como se ve el exito.',
    charactersOver: '{count} caracteres sobre el limite',
    charactersRemaining: '{count} caracteres restantes',
    submitIssue: 'Enviar problema',
    submitting: 'Enviando...',
    error: 'Algo salio mal. Intentalo de nuevo.',
    ticketSubmitted: 'Ticket enviado',
    ticketInQueue: '{referenceNumber} ya esta en la cola.',
    evaluating: 'Evaluando tu problema...',
    moreDetails: 'Se necesitan algunos detalles mas',
    answerPlaceholder: 'Tu respuesta...',
    submitAdditional: 'Enviar informacion adicional',
    viewTicket: 'Ver ticket',
    promptText: 'Describe el problema con detalle, incluyendo lo que observaste y cuando inicio.',
    waitingBody: 'Estamos verificando si necesitamos informacion adicional antes de enrutar tu problema a un experto. Esto suele tomar algunos segundos, por favor espera.',
    needsInfoBody: 'Para ayudar a nuestro experto a responder lo mas rapido posible, responde las preguntas a continuacion.',
    completeBody: 'Tu problema ya esta en la cola y un experto lo revisara pronto. Recibiras un correo cuando respondan.',
  },
  inbox: {
    title: 'Bandeja de expertos',
    shown: '{count} mostrados',
    project: 'Proyecto',
    allProjects: 'Todos los proyectos',
    category: 'Categoria',
    allCategories: 'Todas las categorias',
    priority: 'Prioridad',
    priorityHelp: 'La prioridad la selecciona el gerente de linea al enviar. Ordenar por prioridad pone primero los tickets criticos y de alta prioridad.',
    allPriorities: 'Todas las prioridades',
    status: 'Estado',
    statusHelp: 'El estado muestra donde esta el ticket en el flujo, desde triaje de IA hasta revision experta, respuesta, seguimiento y cierre.',
    allUnresponded: 'Todos sin respuesta',
    allStatuses: 'Todos los estados',
    sort: 'Orden',
    sortHelp: 'Elige si la bandeja se ordena por envio, ocurrencia del problema o prioridad reportada por el gerente de linea.',
    dateSubmitted: 'Fecha de envio',
    dateOfOccurrence: 'Fecha de ocurrencia',
    userPriority: 'Prioridad del usuario',
    applyFilters: 'Aplicar filtros',
    reset: 'Restablecer',
    clearTitle: 'Bandeja vacia',
    clearBody: 'Los tickets apareceran cuando termine el resumen.',
    statusLabels: {
      SUBMITTED: 'Esperando triaje de IA',
      NEEDS_INFO: 'Necesita informacion',
      TRIAGED: 'Clasificado',
      AWAITING_EXPERT: 'Listo para revision',
      EXPERT_REVIEWING: 'En revision experta',
      RESPONSE_DRAFTING: 'Redactando',
      RESPONSE_READY: 'Respuesta lista',
      RESPONDED: 'Respondido',
      CLOSED: 'Cerrado',
    },
  },
  tickets: {
    title: 'Mis tickets',
    intro: 'Da seguimiento a los problemas que enviaste al equipo experto.',
    newTicket: 'Nuevo ticket',
    emptyTitle: 'Aun no hay tickets',
    emptyBody: 'Los problemas enviados apareceran aqui.',
    issueSubmitted: 'Problema enviado',
    occurred: 'Ocurrio {date}',
    updated: 'Actualizado {date}',
  },
  ticketDetail: {
    issueSubmitted: 'Problema enviado',
    degradedAi: 'El procesamiento de IA no esta disponible. Un experto revisara tu ticket manualmente.',
    aiSummary: 'Resumen de IA',
    project: 'Proyecto',
    dateOfOccurrence: 'Fecha de ocurrencia',
    department: 'Departamento',
    issueCategory: 'Categoria del problema',
    affectedSystem: 'Sistema afectado',
    declaredPriority: 'Prioridad declarada',
    actionRequested: 'Accion solicitada',
    successCriteria: 'Criterios de exito',
    waitingForLineManager: 'Esperando informacion del gerente de linea',
    waitingForLineManagerBody: 'La IA pidio informacion adicional al gerente de linea antes de enrutar este ticket para respuesta experta.',
    expertOverrideResponse: 'Respuesta manual del experto',
    expertOverrideBody: 'Puedes responder ahora, incluso si el analisis de IA, el borrador o la aclaracion siguen en progreso.',
    responseDraft: 'Borrador de respuesta',
    responseDraftBody: 'Genera un borrador basado en KB para revision experta.',
    generatingDraft: 'Generando borrador de respuesta... normalmente toma unos segundos.',
    kbSources: 'Fuentes de KB',
    regenerateDraft: 'Regenerar borrador',
    noKbSources: 'No se usaron fuentes de KB.',
    knowledgeGaps: 'Brechas de conocimiento',
    clarificationForm: {
      heading: 'Para ayudar a nuestro experto a responder rapidamente, por favor responde lo siguiente:',
      submitButton: 'Enviar informacion adicional',
      submitting: 'Enviando…',
      minWords: 'Escribe al menos algunas palabras.',
      error: 'Algo salio mal. Intentalo de nuevo.',
    },
    closeButton: {
      label: 'Cerrar ticket',
      closing: 'Cerrando…',
      error: 'Error al cerrar el ticket',
      generic: 'Algo salio mal',
      confirmTitle: '¿Cerrar este ticket?',
      confirmBody: 'Una vez cerrado, el ticket dejara de estar activo. Aun podras verlo en el archivo.',
      confirmCancel: 'Cancelar',
      confirmClose: 'Cerrar ticket',
    },
    expertResponseForm: {
      responseLabel: 'Respuesta del experto',
      severity: 'Severidad',
      severityTooltip: 'Clasifica el impacto operativo del problema despues de la revision. Estos metadatos ayudan a los informes y recomendaciones futuras de KB.',
      selectSeverity: 'Selecciona severidad…',
      concernType: 'Tipo de problema',
      concernTooltip: 'Captura la razon principal por la que este problema necesito apoyo experto, como una brecha de proceso, de conocimiento o de orientacion.',
      selectConcern: 'Selecciona problema…',
      confirmAiDraftTitle: 'Enviar borrador sin cambios?',
      confirmAiDraft: 'Estas por enviar el borrador de IA sin cambios. Confirma que lo revisaste y apruebas enviarlo como respuesta del experto.',
      confirmAiDraftSend: 'Confirmado, enviar',
      confirmAiDraftCancel: 'Espera, no enviar',
      send: 'Enviar respuesta',
      sending: 'Enviando...',
      error: 'No se pudo enviar la respuesta',
      translationPreviewHeading: 'Traduccion para el solicitante (ingles)',
      translationPreviewNote: 'Este solicitante prefiere el ingles. Revisa la traduccion de IA abajo antes de enviar.',
      translationGenerating: 'Generando traduccion…',
      translationError: 'No se pudo generar la traduccion — puedes ingresarla manualmente.',
      translationStaleWarning: 'El texto de la respuesta cambio. Actualiza la traduccion antes de enviar.',
      regenerateTranslation: 'Regenerar',
      sendWithTranslation: 'Revisar traduccion y enviar',
    },
    followUpForm: {
      awaitingReplyHeading: 'Responder al experto',
      awaitingReplyBody: 'El experto ha pedido mas informacion. Responde abajo y tu ticket sera revisado nuevamente.',
      awaitingReplyPlaceholder: 'Agrega tu informacion de seguimiento aqui…',
      awaitingReplyButton: 'Enviar respuesta',
      followUpHeading: 'Seguimiento con el experto',
      followUpBody: 'El experto ha respondido a tu ticket. Usa el formulario si tienes mas preguntas o comentarios.',
      followUpPlaceholder: 'Escribe tu seguimiento aqui…',
      followUpButton: 'Enviar seguimiento',
      sending: 'Enviando…',
      replyError: 'Error al enviar la respuesta',
      generic: 'Algo salio mal',
      minWords: 'Escribe al menos algunas palabras.',
    },
    expertReplyForm: {
      heading: 'Responder al gerente de linea',
      body: 'El gerente de linea respondio a tu respuesta. Envia un mensaje de seguimiento abajo.',
      placeholder: 'Escribe tu seguimiento aqui…',
      send: 'Enviar respuesta',
      sending: 'Enviando…',
      error: 'Error al enviar la respuesta',
      generic: 'Algo salio mal',
      minWords: 'Escribe al menos algunas palabras.',
    },
    draftButton: {
      generate: 'Generar respuesta',
      retryDraft: 'Reintentar borrador',
      generating: 'Generando…',
      error: 'No se pudo solicitar el borrador',
    },
    tagEditor: {
      title: 'Etiquetas',
      tooltip: 'Las etiquetas ayudan a los expertos a organizar tickets, encontrar trabajo relacionado y mejorar el filtrado y los informes.',
      hint: 'Presiona Enter o coma para agregar. Hasta 10 etiquetas.',
      placeholder: 'Agregar etiquetas…',
      saving: 'Guardando…',
      error: 'Error al guardar etiquetas',
      networkError: 'Error de red — intentalo de nuevo',
    },
  },
  adminUsers: {
    title: 'Usuarios',
    intro: 'Administra miembros del equipo. Los usuarios invitados pueden iniciar sesion con su correo por magic link o Google SSO.',
    inviteTitle: 'Invitar nuevo miembro',
    email: 'Correo',
    role: 'Rol',
    language: 'Idioma',
    addUser: 'Agregar usuario',
    adding: 'Agregando...',
    failedInvite: 'No se pudo invitar al usuario',
    inviteSuccess: '{email} ya puede iniciar sesion. Se le envio una invitacion por correo.',
    activeMembers: 'Miembros activos',
    countFiltered: '{filtered} de {total}',
    filterPlaceholder: 'Filtrar por nombre o correo',
    disabled: 'Deshabilitados',
    none: 'Ninguno',
    member: 'Miembro',
    lastLogin: 'Ultimo inicio',
    actions: 'Acciones',
    you: 'tu',
    never: 'Nunca',
    disable: 'Deshabilitar',
    reEnable: 'Rehabilitar',
    actionFailed: 'La accion fallo',
    roleHelp: 'Los gerentes de linea pueden enviar y seguir sus tickets. Los expertos pueden revisar tickets y administrar conocimiento/proyectos. Los admins tambien pueden administrar usuarios y configuracion del tenant.',
    activeHelp: 'Deshabilitar a un miembro bloquea el acceso a este tenant sin borrar su usuario ni su actividad historica.',
  },
  knowledge: {
    title: 'Base de conocimiento',
    intro: 'Busca, redacta y revisa conocimiento operativo verificado.',
    entries: '{count} entradas',
    emptyTitle: 'Aun no hay entradas',
    emptyBody: 'Crea la primera entrada markdown verificada.',
    updated: 'Actualizado',
    queued: 'en cola',
    editEntry: 'Editar entrada',
    createEntry: 'Crear entrada',
    newEntry: 'Nueva entrada',
    form: {
      fieldTitle: 'Titulo',
      titlePlaceholder: 'Fallo de filler E42 en linea 3',
      slug: 'Slug',
      slugTooltip: 'El slug es el identificador URL estable de esta entrada. Dejalo en blanco para generarlo del titulo.',
      slugPlaceholder: 'auto-generado si esta en blanco',
      type: 'Tipo',
      typeTooltip: 'Elige la forma del conocimiento: concepto para contexto, procedimiento para pasos, entidad para equipos o sistemas, registro para eventos, e indice para navegacion.',
      tags: 'Etiquetas',
      tagsTooltip: 'Las etiquetas ayudan a encontrar orientacion relacionada y mejoran el contexto de recuperacion para borradores de IA.',
      tagsHint: 'Presiona Enter o coma para agregar. Hasta 10 etiquetas.',
      tagsPlaceholder: 'Agregar etiquetas...',
      markdown: 'Markdown',
      markdownTooltip: 'Reemplaza el ejemplo con orientacion verificada y reutilizable. Este contenido puede recuperarse para futuros borradores asistidos por IA.',
      preview: 'Vista previa',
      previewEmpty: 'La vista previa del markdown aparece aqui mientras escribes.',
      saving: 'Guardando...',
      update: 'Actualizar entrada',
      create: 'Crear entrada',
      sampleError: 'Reemplaza el markdown de ejemplo con conocimiento verificado antes de crear una entrada.',
      saveError: 'No se pudo guardar la entrada de KB',
    },
    search: {
      placeholder: 'Buscar procedimientos, sintomas, equipos...',
      searching: 'Buscando...',
      search: 'Buscar',
    },
    proposals: {
      heading: 'Revision de conocimiento',
      intro: 'Las respuestas de expertos crearon estas actualizaciones de KB pendientes.',
      accept: 'Aceptar',
      dismiss: 'Descartar',
      error: 'No se pudo revisar la propuesta',
    },
    translation: {
      heading: 'Traduccion al espanol',
      statusApproved: 'Aprobada',
      statusPending: 'Pendiente de revision',
      statusStale: 'Desactualizada — la fuente cambio',
      noTranslation: 'Aun no hay traduccion al espanol.',
      generate: 'Generar con IA',
      generating: 'Generando…',
      generateError: 'No se pudo generar la traduccion',
      approve: 'Aprobar',
      reject: 'Rechazar',
      approving: 'Aprobando…',
      rejecting: 'Rechazando…',
      reviewError: 'No se pudo actualizar la traduccion',
      editTranslation: 'Editar traduccion',
      saveTranslation: 'Guardar traduccion',
      savingTranslation: 'Guardando…',
      saveTranslationError: 'No se pudo guardar la traduccion',
      translatedBadge: 'Traducida',
      staleBadge: 'Traduccion desactualizada',
      canonicalNote: 'Editar aqui actualiza solo la traduccion al espanol. La entrada canonica en ingles no cambia.',
    },
  },
  adminConfig: {
    title: 'Configuracion del tenant',
    intro: 'Los cambios aplican inmediatamente a nuevos trabajos de IA. Los trabajos en curso no se ven afectados.',
    missing: 'No se encontro la configuracion del tenant.',
    submissionUi: 'Interfaz de envio',
    submissionPromptText: 'Texto del prompt de envio',
    additionalInfoPromptText: 'Texto del prompt de informacion adicional',
    maxSubmissionChars: 'Max. caracteres de envio',
    maxCharsHint: '500–20 000',
    aiSettings: 'Configuracion de IA',
    aiModel: 'Modelo de IA',
    aiModelTooltip: 'Controla que modelo maneja verificaciones de completitud, resumenes, borradores y propuestas de KB para este tenant.',
    temperature: 'Temperatura',
    temperatureHint: '0.0 (determinista) – 1.0 (creativo)',
    temperatureTooltip: 'Valores bajos hacen la salida de IA mas consistente. Valores altos la hacen mas variada, util para borradores pero mas riesgosa para orientacion regulada.',
    minInfoScore: 'Umbral minimo de informacion',
    minInfoScoreHint: '0.0–1.0 — tickets por debajo activan aclaracion',
    minInfoScoreTooltip: 'Sube o baja que tan estricto es el agente de completitud antes de pedir mas informacion al gerente.',
    maxClarificationCycles: 'Max. ciclos de aclaracion',
    maxCyclesHint: '0–10',
    aiJobTimeout: 'Tiempo de espera del trabajo de IA (segundos)',
    timeoutHint: '30–600',
    dataCompliance: 'Datos y cumplimiento',
    dataProcessingConsent: 'Consentimiento de procesamiento de datos — permitir que el contenido de tickets se envie al proveedor de IA',
    dataProcessingTooltip: 'Cuando esta deshabilitado, el contenido de tickets del tenant no debe enviarse al proveedor de IA configurado; los expertos aun pueden manejar tickets manualmente.',
    save: 'Guardar cambios',
    saving: 'Guardando…',
    saved: 'Guardado correctamente.',
    saveError: 'Error al guardar la configuracion',
    networkError: 'Error de red — intentalo de nuevo',
  },
  platformHealth: {
    title: 'Salud de la plataforma',
    intro: 'Adopcion, flujo de tickets, calidad de borradores y salud de KB por tenant.',
    adoption: 'Adopcion',
    ticketFlowHealth: 'Flujo de tickets',
    draftQuality: 'Calidad de borradores',
    kbHealth: 'Salud de KB',
    activeThisWeek: 'Activos esta semana',
    activeThisMonth: 'Activos este mes',
    activationRate: 'Tasa de activacion',
    activationRateDetail: 'Usuarios activos con al menos una accion real',
    ticketsPerActiveLm: 'Tickets / gerente activo',
    ticketsPerActiveLmDetail: 'Semana calendario actual',
    orphanedTickets: 'Tickets sin atencion',
    orphanedTicketsDetail: 'Sin mensaje de experto en las ultimas 48 horas',
    medianFirstAction: 'Primera accion mediana',
    medianFirstActionDetail: 'Envio hasta primera respuesta experta',
    followUpRate: 'Tasa de seguimiento',
    followUpRateDetail: 'Tickets respondidos con seguimiento del gerente',
    closedWithoutClarification: 'Cerrados sin aclaracion',
    closedWithoutClarificationDetail: 'Solo metrica indirecta',
    closedWithoutClarificationNote: 'Resueltos sin canales externos es una metrica indirecta: mide tickets cerrados que nunca entraron a NEEDS_INFO, no el comportamiento fuera del canal.',
    draftSendThrough: 'Borradores aceptados',
    draftSendThroughDetail: 'Borradores de IA aceptados',
    draftEditRate: 'Tasa de edicion',
    draftEditRateDetail: 'Borradores de tickets enviados marcados como editados',
    draftRegeneration: 'Regeneracion de borradores',
    draftRegenerationDetail: 'Tickets con multiples borradores',
    activeKbEntriesMetric: 'Entradas KB activas',
    activeKbEntriesMetricDetail: 'No eliminadas',
    usedInDrafts: 'Usadas en borradores',
    usedInDraftsDetail: 'Recuperadas al menos una vez',
    neverRetrieved: 'Nunca recuperadas',
    neverRetrievedDetail: 'Candidatas para revision',
    contributingEntries: 'Entradas contribuyentes',
    contributingEntriesDetail: 'Recuperadas para tickets respondidos',
    week: 'Semana',
    submissions: 'Envios',
  },
  aiUsage: {
    title: 'Uso de IA',
    intro: 'Volumen de llamadas de IA, latencia, fallos y gasto estimado del tenant.',
    from: 'Desde',
    to: 'Hasta',
    refresh: 'Actualizar',
    totalCalls: 'Total de llamadas',
    successRate: 'Tasa de exito',
    totalTokens: 'Total de tokens',
    estimatedCost: 'Costo estimado',
    perAgentBreakdown: 'Desglose por agente',
    agent: 'Agente',
    calls: 'Llamadas',
    success: 'Exito',
    p50Latency: 'Latencia P50',
    p95Latency: 'Latencia P95',
    cost: 'Costo',
    noCallsFound: 'No se encontraron llamadas de IA para este rango de fechas.',
    recentErrors: 'Errores recientes',
    time: 'Hora',
    code: 'Codigo',
    message: 'Mensaje',
    noErrorsFound: 'No se encontraron llamadas de IA fallidas para este rango de fechas.',
  },
  projects: {
    title: 'Proyectos',
    intro: 'Administra la lista de proyectos que los gerentes de linea seleccionan al enviar tickets.',
    projectNamePlaceholder: 'Nombre del proyecto',
    addProject: 'Agregar proyecto',
    adding: 'Agregando…',
    deactivate: 'Desactivar',
    addError: 'Error al agregar el proyecto',
    noProjects: 'No hay proyectos activos.',
    createdBy: 'Creado por',
  },
  switchTenant: {
    title: 'Cambiar tenant',
    intro: 'Tienes acceso a multiples tenants. Selecciona uno para continuar.',
    current: 'Actual',
    switch: 'Cambiar',
    switching: 'Cambiando…',
    loading: 'Cargando…',
  },
} as const satisfies EnglishDictionary
